/**
 * The app used to ship as a PWA with a precaching service worker.
 * That is gone, but browsers keep a previously installed worker alive
 * indefinitely — it would keep serving the old cached bundle.
 *
 * This tears down any leftover registration and its caches. The current
 * page was itself served by that worker, so when one actually existed we
 * reload once to pick up the real bundle. Visitors without a worker
 * (everyone, after the first visit) never reload.
 */
export const unregisterServiceWorker = (): void => {
    if (!('serviceWorker' in navigator)) {
        return;
    }

    navigator.serviceWorker
        .getRegistrations()
        .then((registrations) => {
            const hadWorker = registrations.length > 0;

            return Promise.all(
                registrations.map((registration) => registration.unregister()),
            ).then(() => hadWorker);
        })
        .then((hadWorker) => {
            if (!hadWorker) {
                return false;
            }

            if (!('caches' in window)) {
                return true;
            }

            return caches
                .keys()
                .then((keys) =>
                    Promise.all(keys.map((key) => caches.delete(key))),
                )
                .then(() => true);
        })
        .then((shouldReload) => {
            if (shouldReload) {
                window.location.reload();
            }
        })
        .catch((error) => {
            console.error('Failed to remove legacy service worker:', error);
        });
};

export default unregisterServiceWorker;
